import type { RouteObject } from 'react-router';
import { PageAdministration } from './PageAdministration.tsx';
import { PageCompte } from './PageCompte.tsx';

export const routesAdmin: RouteObject[] = [
  { path: 'administration', element: <PageAdministration /> },
  { path: 'compte', element: <PageCompte /> },
];
